import { getDefaultCampaignPagination } from "campaign/tools/list"
import { NO_CREATION_DATE_FILTER } from "ui/model"
import { isDesktopScreen } from "ui/tools/responsive"
import { getAllCampaignLanguages, ICampaignFilters, ICampaignList, ICampaignState } from "../model"

export function getDefaultCampaignState(): ICampaignState {
  return {
    campaignList: getDefaultListState(false, false),
    forecastList: getDefaultListState(true, false),
    dspDealList: getDefaultListState(false, true),
    availableLanguages: getAllCampaignLanguages(),
    statuses: [],
    types: [],
    duplicatePopup: {
      campaign: null,
      isForecastConvert: false,
      isSaving: false
    }
  }
}

export function getDefaultFilters(isForecast: boolean): ICampaignFilters {
  return {
    isForecast,
    advertiserIds: [],
    name: "",
    orderIds: [],
    statuses: [],
    creationDate: NO_CREATION_DATE_FILTER,
    startEndPeriod: {
      endDate: null,
      startDate: null
    }
  }
}

function getDefaultListState(isForecast: boolean, isDspDeal: boolean): ICampaignList {
  return {
    isForecast,
    isDspDeal,
    filteredEntities: [],
    filters: getDefaultFilters(isForecast),
    isFilterExpanded: isDesktopScreen(),
    isRefreshing: false,
    hasRefreshError: false,
    pagination: getDefaultCampaignPagination(),
    isLoadingReports: false,
    isLoadingEstimates: false,
    rowCount: 0,
    isLoadingDspDeal: false
  }
}
